export default __webpack_public_path__ + "static/media/leaflet_map_img.d1c622ec.png";